import { render } from "./Main.vue?vue&type=template&id=2d68da41&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=2d68da41&scoped=true&lang=css"
import "./Main.vue?vue&type=style&index=1&id=2d68da41&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d68da41"]])

export default __exports__